module.exports = __webpack_public_path__ + "img/avatar-default-male.a95b4e98.png";